/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from './ui/__generated__/DefaultFeaturesSettingsPageViewQuery$parameters';
import type { FeaturesEntryPointEntrypointProps } from './ui/FeaturesEntryPoint.entrypoint.types.tsx';
import type { Queries } from './ui/types.tsx';

const toPlanAri = ({
	siteId,
	activationId,
	planId,
}: {
	siteId: string;
	activationId: string;
	planId: string;
}): string => {
	return `ari:cloud:jira:${siteId}:plan/activation/${activationId}/${planId}`;
};

type FeaturesEntryPointComponentType = EntryPointComponent<
	Queries,
	{},
	FeaturesEntryPointEntrypointProps,
	{}
>;

export const featuresEntryPoint: EntryPoint<
	FeaturesEntryPointComponentType,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<FeaturesEntryPointComponentType>(
		/* webpackChunkName: "async-plan-features-entrypoint" */ './ui/DefaultFeaturesSettingsPageView.tsx',
		{ entryFsSsrLiftImportToModule: true },
	),
	getPreloadProps: ({ context: { match }, tenantContext }: EntryPointRouteParams) => {
		return {
			queries: {
				plan: {
					variables: {
						planId: toPlanAri({
							siteId: tenantContext.cloudId,
							activationId: tenantContext.activationId,
							planId: String(match.params.planId),
						}),
					},
					options: {
						fetchPolicy: 'network-only' as const,
					},
					parameters,
				},
			},
		};
	},
});
